export default {
  rewards: {
    title: "รางวัล",
    claim: "รับ",
    weeklyCashback: "คืนเงินรายสัปดาห์",
    weeklyCashbackDesc: "รับเงินคืนบางส่วนจากการเสียในแต่ละสัปดาห์",
    dailySpin: "หมุนวงล้อรายวัน",
    dailySpinDesc: "หมุนวงล้อทุกวันเพื่อลุ้นรางวัลใหญ่",
    invitationBonus: "โบนัสเชิญเพื่อน",
    invitationBonusDesc: "ชวนเพื่อนเข้าร่วมและรับรางวัลสำหรับทุกคนที่สมัคร",
    rebate: "รีเบต",
    rebateDesc: "รับรีเบตจากทุกการเดิมพัน ไม่ว่าจะแพ้หรือชนะ",
    bannerTitle: "รางวัล",
    bannerSubtitle: "ทำภารกิจให้สำเร็จและรับรางวัลสุดพิเศษ!",
    sectionTitle: "รางวัลสุดพิเศษของคุณ",
    goNow: "ไปเลย",
    historyReceived: "ทั้งหมดที่ได้รับ",
    todayReceived: "ได้รับวันนี้",
    cashbackDialog: {
      title: "เงินคืนจากการเดิมพัน",
      loading: "กำลังโหลด...",
      empty: "ไม่มีกฎเงินคืน",
      level: "ระดับ",
      amountRange: "ช่วงจำนวนเงิน",
      rewardRate: "อัตรารางวัล",
      rewardCap: "วงเงินรางวัล",
    },
    cards: {
      checkin: {
        title: "เช็คอินรายวัน",
        subtitle: "เข้าสู่ระบบเพื่อเช็คอินทุกวัน",
        description: "อย่าลืมเช็คอินทุกวันนะ~",
      },
      cashback: {
        title: "คืนเงิน",
        subtitle: "รางวัลรีเบตจากแพลตฟอร์ม",
      },
      rescue: {
        title: "โบนัสช่วยเหลือ",
        subtitle: "เล่นเกมเงินสด 3 ครั้ง",
        description: "เงินช่วยเหลือสำหรับผู้เล่นที่หมดตัว",
      },
      task: {
        title: "ภารกิจ",
        subtitle: "ทำภารกิจของแพลตฟอร์ม",
        description: "ภารกิจของแพลตฟอร์ม",
      },
      balance: {
        title: "ตู้เซฟ",
        subtitle: "รับดอกเบี้ยรายวัน",
        description: "ตู้เซฟของแพลตฟอร์ม",
      },
      loan: {
        title: "โบนัสยืมเงิน",
        subtitle: "ยืมเงินได้ง่าย",
        description: "การยืมเงินของแพลตฟอร์ม",
      },
    },
    checkIn: {
      dailySignIn: "เช็คอินรายวัน",
      totalRewards: "รางวัลรวม",
      headlineDaysBefore: "เช็คอินต่อเนื่อง",
      headlineDaysAfter: "วัน",
      headlineTailCumulative: "ถ้าขาดสักวันก็ไม่เป็นไร",
      headlineTailDate: "ถ้าขาดวันไหนก็จะเสียรางวัลของวันนั้น",
      headlineCumulative: "เช็คอินครบ {days} วันเพื่อรับรางวัลใหญ่ ขาดวันได้ไม่มีปัญหา",
      headlineDate: "เช็คอินครบ {days} วัน ขาดวันไหนก็เสียรางวัลของวันนั้น",
      headlineEmpty: "เช็คอินเพื่อรับรางวัล",
      title: "เช็คอิน",
      modeCumulative: "เช็คอินสะสม",
      modeDate: "เช็คอินตามวันที่",
      rewards: "รางวัล",
      signedIn: "เช็คอินแล้ว",
      day: "วันที่ {n}",
      loading: "กำลังโหลด...",
      empty: "ไม่มีกิจกรรมเช็คอินที่เปิดใช้งาน",
      btnCheckIn: "เช็คอิน",
      btnSigned: "เช็คอินแล้ว",
      btnLocked: "ล็อค",
      claimSuccess: "เช็คอินสำเร็จ ได้รับรางวัล {amount} {currency}",
      claimFailed: "เช็คอินไม่สำเร็จ",
      alreadySigned: "คุณเช็คอินวันนี้แล้ว",
      notLogin: "กรุณาเข้าสู่ระบบก่อน",
    },
  },
};
